import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import { EPIK_MAX_AGE } from './constants';
import { PinterestClickIdentifiers } from './types';

export const usePinterestClickIdentifiers = (): PinterestClickIdentifiers => {
	const [cookies, setCookie] = useCookies(['_epik']);
	const searchParams = useSearchParams();
	const epikFromUrl = searchParams?.get('epik') ?? undefined;

	useEffect(() => {
		if (epikFromUrl && epikFromUrl !== cookies._epik) {
			setCookie('_epik', epikFromUrl, {
				path: '/',
				maxAge: EPIK_MAX_AGE,
			});
		}
	}, [epikFromUrl, cookies._epik, setCookie]);

	return {
		epik: cookies._epik || epikFromUrl,
	};
};
